import type { PublicApiKey } from '#packages/apilib';
import type { createPrivateAppsEventsApi } from './api';

export const PrivateAppsEventsApiKey: PublicApiKey<
  typeof createPrivateAppsEventsApi
> = {
  name: 'PrivateAppsDuplexerApi',
  public: true,
};
